import { render, staticRenderFns } from "./GeneralTab.vue?vue&type=template&id=326eff34"
import script from "./GeneralTab.vue?vue&type=script&lang=js"
export * from "./GeneralTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports